export const REVIEWER_MANDATE = `
# Reviewer Mandate

- Verify claimed completion against source files, tests, build output, and integration paths.
- Mark TODO items complete only after direct evidence confirms the requested behavior.
- Report residual risk clearly when the environment prevents full validation.
`;
